import { createApi } from '@reduxjs/toolkit/query/react';
import { route } from '../routes/web';
import { baseQuery } from './baseQuery';

export const landingAPI = createApi({
    reducerPath: 'api',
    baseQuery: baseQuery,
    tagTypes: ['PRODUCT', 'ACTIVE_TYPES'],
    endpoints: (builder) => ({
        getLandingProducts: builder.query({
            query: ({ point, id, page }) => {
                return {
                    route: route.shop.list,
                    transformUrl: (url) => `${url}/${id}`,
                    data: {
                        point,
                        page,
                    },
                };
            },
            providesTags: ['PRODUCT'],
        }),
        getLandingTypes: builder.query({
            query: ({ point, id }) => {
                return {
                    transformUrl: (url) => `${url}/${id}`,
                    route: route.shop.listTypes,
                    data: {
                        point,
                    },
                };
            },
        }),
        getActiveTypes: builder.query({
            providesTags: ['ACTIVE_TYPES'],
            query: ({ point }) => {
                return {
                    route: route.shop.listTypes,
                    data: {
                        point,
                    },
                };
            },
        }),
        getProducts: builder.query({
            query: ({ type_id, point, page }) => {
                return {
                    route: route.shop.list,
                    data: {
                        point,
                        type_id,
                        page,
                    },
                };
            },
        }),
    }),
});

export const {
    useGetLandingProductsQuery,
    useGetLandingTypesQuery,
    useGetActiveTypesQuery,
    useLazyGetProductsQuery,
} = landingAPI;
